import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import Swal from "sweetalert2";
import {
  AddSubObjectives,
  GetSubObjectivesById,
  restValidateSubObjectives,
  UpdateSubObjectives,
  ValidateSubObjectives,
} from "../../../Redux/Reducers/ReportStage/SubObjectives";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
import InputAHSF from "../../../Components/InputAHSF";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import LoaderAHSF from "../../../Components/LoaderAHSF";

const AddEditSubObjective = (props) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      SubObjectives: state.SubObjectives.SubObjectives,
      loadingSubObjectives: state.SubObjectives.loadingSubObjectives,

      SubObjectivesValidate: state.SubObjectives.SubObjectivesValidate,
      //   ApplicationInformation:
      //     state.ApplicationInformationReducer.ApplicationInformation,
    };
  });
  console.log(state.SubObjectives, "rrrrrrr");

  const ActiveRound = useSelector((state) => state.RoundReducers.ActiveRound);
  const ApplicationInformation = useSelector(
    (state) => state.ApplicationInformationReducers.ApplicationInformation
  );

  const [SubObjective, setSubObjective] = useState({
    subObjectivesId: state.SubObjectives?.subObjectivesId,
    subObjectivesName: state.SubObjectives?.subObjectivesName,
    reportId: props.reportId,
  });
  console.log(SubObjective, "sssssssss");

  const [validateSubObjective, setValidateSubObjective] = useState(false);

  const AddSub = async () => {
    if (
      SubObjective != null &&
      SubObjective.subObjectivesName != null &&
      SubObjective.subObjectivesName.trim() !== ""
    ) {
      setValidateSubObjective(false);

      await dispatch(
        AddSubObjectives({
          subObjectivesName: SubObjective.subObjectivesName,
          reportId: props.reportId,
        })
      );

      $(".close-btn").trigger("click");

      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم اضافة المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });

      dispatch(setRefreshTable());
    } else {
      setValidateSubObjective(true);
    }
  };

  useEffect(() => {
    dispatch(restValidateSubObjectives());
  }, []);
  console.log(SubObjective.subObjectivesId, "ssssssssssssssd");

  const UpdateSub = async () => {
    if (
      SubObjective != null &&
      SubObjective.subObjectivesName != null &&
      SubObjective.subObjectivesName.trim() !== ""
    ) {
      setValidateSubObjective(false);

      await dispatch(
        UpdateSubObjectives({
          subObjectivesId: SubObjective.subObjectivesId,
          subObjectivesName: SubObjective.subObjectivesName,
          reportId: props.reportId,
        })
      );

      $(".close-btn").trigger("click");

      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم تعديل المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });

      dispatch(setRefreshTable());
    } else {
      setValidateSubObjective(true);
    }
  };

  useEffect(() => {
    if (props != null) {
      dispatch(
        GetSubObjectivesById({ subObjectivesId: props.subObjectivesId })
      );
    }
  }, [props.SubObjectiveId]);
  useEffect(() => {
    if (!state.loadingSubObjectives && Object.keys(props).length != 0) {
      setSubObjective({
        ...state.SubObjectives,
      });
    } else {
      setSubObjective({
        subObjectivesName: null,

        reportId: props.reportId,
      });
    }
  }, [state.SubObjectives]);

  const shouldDisableFields = !(
    ActiveRound == ApplicationInformation?.aI_RoundYearId &&
    ApplicationInformation?.sU_ST_MRI_ApplicationStatus?.canEdit &&
    window.location.href.includes("manager") == false
  );
  return (
    <>
      {!state.loadingSubObjectives ? (
        <>
          <div className="AddEdite">
            <InputAHSF
              fieldsName="SubObjective"
              show={true}
              //   disabled={shouldDisableFields}
              onChange={(e) => {
                setSubObjective({
                  ...SubObjective,
                  subObjectivesName: e.target.value,
                });
              }}
              defaultValue={state.SubObjectives?.subObjectivesName}
              showValidationMessage={validateSubObjective ? true : false}
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            {/* {!shouldDisableFields ? ( */}
            <div className="containersButton">
              <div>
                <ButtonAHSF
                  type={"submitter"}
                  onClick={() => {
                    props.canEdit == "edit" ? UpdateSub() : AddSub();
                  }}
                  disabled={false}
                  title={props.canEdit == "edit" ? "تعديل" : "إضافة"}
                  text={props.canEdit == "edit" ? "تعديل" : "إضافة"}
                  show={true}
                />
              </div>
            </div>
            {/* ) : (
              ""
            )} */}
          </div>
        </>
      ) : (
        ""
      )}
      <LoaderAHSF show={state.loadingSubObjectives} />
    </>
  );
};

export default AddEditSubObjective;
